import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PayrollRoutingModule } from './payroll-routing.module';
import { BankListComponent } from './bank/bank-list/bank-list.component';
import { BankCrudComponent } from './bank/bank-crud/bank-crud.component';
import { SalaryCrudComponent } from './salary/salary-crud/salary-crud.component';
import { SalaryListComponent } from './salary/salary-list/salary-list.component';
import { TimelineListComponent } from './timeline/timeline-list/timeline-list.component';
import { TimelineCrudComponent } from './timeline/timeline-crud/timeline-crud.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { HighchartsChartModule } from 'highcharts-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { TimelinesComponent } from './timelines/timelines.component';
import { PaymentCrudComponent } from './payment/payment-crud/payment-crud.component';
import { PaymentListComponent } from './payment/payment-list/payment-list.component';
import { ParticularCrudComponent } from './particular/particular-crud/particular-crud.component';
import { ParticularListComponent } from './particular/particular-list/particular-list.component';
import { ProvidentFundsListComponent } from './Provident-funds/provident-funds-list/provident-funds-list.component';
import { ProvidentFundsCrudComponent } from './Provident-funds/provident-funds-crud/provident-funds-crud.component';
import { SalarySlipComponent } from './payment/salary-slip/salary-slip.component';
import { RenumarationComponent } from './payment/renumaration/renumaration.component';
import { OrgChartComponent } from './org-chart/org-chart/org-chart.component';
import { NgxOrgChartModule } from 'ngx-org-chart';
import { DueCheckComponent } from './payment/due-check/due-check.component';
import { SalaryPaymentComponent } from './salary-payment/salary-payment.component';


@NgModule({
  declarations: [
    BankListComponent,
    BankCrudComponent,
    SalaryCrudComponent,
    SalaryListComponent,
    TimelineListComponent,
    TimelineCrudComponent,
    TimelinesComponent,
    PaymentCrudComponent,
    PaymentListComponent,
    ParticularCrudComponent,
    ParticularListComponent,
    ProvidentFundsListComponent,
    ProvidentFundsCrudComponent,
    SalarySlipComponent,
    RenumarationComponent,
    OrgChartComponent,
    DueCheckComponent,
    SalaryPaymentComponent,
  ],
  imports: [
    CommonModule,
    PayrollRoutingModule,
    PerfectScrollbarModule,
    HighchartsChartModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxOrgChartModule,
  ]
})
export class PayrollModule { }
